import { Badge, HStack, Pressable, Text } from "native-base";
import { Svg } from "react-native-svg";
import { COLORS } from "../../utils/colors";
import { closeBtnSVG } from "../../utils/svg";
import { COMMONFONTSIZE } from "../../utils/fonts";

const CommonBadge = ({
  variant = "subtle",
  colorScheme = COLORS.BADGE_GRAY_COLOR,
  text = "",
  textColor = "",
  borderRadius = "100px",
  closebtn = true,
  handleSelectedValues = () => {},
  selectedIndex = "",
  fontSize = COMMONFONTSIZE.MEDIUM_FONT_SIZE,
  fontWeight = undefined,
}) => {
  return (
    <Badge
      variant={variant}
      bg={colorScheme}
      w="fit-content"
      borderRadius={borderRadius}
    >
      <HStack space={2} alignItems="center" justifyContent="center">
        <Text color={textColor} fontSize={fontSize} fontWeight={fontWeight}>
          {text}
        </Text>
        {closebtn && (
          <Pressable onPress={() => handleSelectedValues(selectedIndex)}>
            <Svg width="10" height="10" viewBox="0 0 10 11">
              {closeBtnSVG}
            </Svg>
          </Pressable>
        )}
      </HStack>
    </Badge>
  );
};

export default CommonBadge;
